import { useTranslation } from "react-i18next";

import { useCan, useSelectedDealer, useSelectedLocation } from "components";
import { useTypedQuery } from "hooks";
import { LocationsOverviewDashboardQueryKeys } from "modules/LocationOverviewDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { TFunction } from "i18next";
import type { DealerLocation } from "models";
import type { Establishment } from "modules/LocationOverviewDashboard/queryKeys";

const selectEstablishments = (establishments: Establishment[], t: TFunction, location: DealerLocation | null) =>
  establishments.map(({ DealerLocationID, Id, Name }) => ({
    text: DealerLocationID ? `${Name} - ${t("v8_assigned", "Assigned")}` : Name,
    key: Id,
    value: Id,
    disabled: DealerLocationID && DealerLocationID !== location?.id
  }));

export const useEstablishmentIdsQuery = () => {
  const { t } = useTranslation();

  const { selectedDealer } = useSelectedDealer();
  const { selectedLocation } = useSelectedLocation();
  const canListDealers = useCan("list", "dealers");

  return useTypedQuery({
    queryKey: LocationsOverviewDashboardQueryKeys.planItEstablishmentIds,
    queryFn: async ({ baseUrl, endpoint }) => (await ApiInstance.post(endpoint, { dealer_id: selectedDealer?.id }, baseUrl)).data.establishments,
    select: establishments => selectEstablishments(establishments, t, selectedLocation),
    refetchOnDependencies: [selectedDealer?.id, selectedDealer?.planit_planning_enabled],
    enabled: canListDealers && !!selectedDealer?.planit_planning_enabled
  });
};
